// components/Layout.jsx
import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import Footer from './Footer';

export default function Layout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const toggleBtnRef = useRef(null);

  // Close sidebar on route change
  useEffect(() => { setOpen(false); }, [location]);

  // Close on Esc
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  // Prevent body scroll when sidebar is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <div className="min-h-screen flex flex-col bg-background dark:bg-background-dark">
      {/* Sidebar */}
      <aside
        id="app-sidebar"
        className={`
          fixed top-0 right-0 h-full w-80 max-w-[85vw]
          bg-white dark:bg-secondary-900
          shadow-sidebar
          z-sidebar
          transform transition-transform duration-300 ease-out
          ${open ? 'translate-x-0' : 'translate-x-full'}
          overflow-y-auto
        `}
        aria-hidden={!open}
      >
        {open && <Sidebar isOpen={open} onNavigate={() => setOpen(false)} />}
      </aside>

      {/* Overlay */}
      {open && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-overlay animate-fade-in"
          onClick={() => setOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Main content */}
      <div className="flex flex-col min-h-screen">
        {/* Header */}
        <header className="sticky top-0 z-header bg-white shadow-sm dark:bg-secondary-900 dark:shadow-secondary-800">
          <div className="max-w-wide mx-auto px-4 sm:px-6">
            <div className="flex items-center justify-between h-16">
              {/* Right side: Menu Button + Logo */}
              <div className="flex items-center gap-4">
              <button
                ref={toggleBtnRef}
                className="
                    p-2 rounded-lg
                  text-secondary-600 dark:text-secondary-300
                  hover:bg-secondary-100 dark:hover:bg-secondary-800
                  focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500
                  transition-colors duration-200
                "
                onClick={() => setOpen(v => !v)}
                aria-controls="app-sidebar"
                aria-expanded={open}
                aria-label={open ? 'סגור תפריט' : 'פתח תפריט'}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  {open ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  )}
                </svg>
              </button>

                {/* Logo and Brand */}
                <Link
                  to="/"
                  className="flex items-center gap-2 cursor-pointer group"
                >
                  <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center text-white font-bold text-xl shadow-md group-hover:bg-primary-700 transition-colors">
                    ת
                  </div>
                  <span className="text-xl font-bold text-secondary-800 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors">
                    הקודש במרכז
                  </span>
                </Link>
              </div>

              {/* Left side: Navigation Links */}
              <nav className="flex items-center gap-6 text-sm font-medium text-secondary-600 dark:text-secondary-300">
                <Link
                  to="/about"
                  className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                >
                  אודות
                </Link>
                <Link
                  to="/inspGreet"
                  className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                >
                  דברי ברכה
                </Link>
              </nav>
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1">
          <Outlet />
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
}
